import React from 'react';

import { useLabels } from '../../i18n/useLabels';
import type { RowFailureViewModel } from '../../viewmodels/rowTypes';

import styles from './QuestionTable.scss';

type Props = {
  viewModel: RowFailureViewModel;
  onRetry: () => void;
};

export function InlineRetry({ viewModel, onRetry }: Props) {
  const { retry, formatMessage } = useLabels();

  return (
    <div className={styles.failure}>
      <span>{formatMessage(viewModel.message)}</span>
      <button
        type="button"
        className={styles.retryButton}
        aria-label={formatMessage(viewModel.retryLabel)}
        onClick={onRetry}
      >
        {retry}
      </button>
    </div>
  );
}
